namespace GeniuzPOS.Inventory {
    export class IcStockWhsColumns {
        static columnsKey = 'Inventory.IcStockWhs';
    }
}
